<template>
  <div>
    <AuthHeaderV2Component
      currentLayout="auth-v2-layout"
      :currentUrl="currentUrl"
    />
    <slot></slot>
    <AuthFooterV2Component v-if="displayFooter" />
  </div>
</template>
<script>
const default_layout = "default";
export default {
  name: "AuthV2Layout",
  components: {
    AuthHeaderV2Component: () =>
      import(
        "@/components/admin/layouts/auth_header_v2/AuthHeaderV2Component.vue"
      ),
    AuthFooterV2Component: () =>
      import(
        "@/components/admin/layouts/auth_footer/AuthFooterV2Component.vue"
      ),
  },
  data: function () {
    return {
      currentUrl: this.$route.matched[0].path.replace(/\//, ""),
    };
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },

    displayFooter() {
      return this.layout == "auth-v2-layout";
    },
  },
  watch: {
    $route() {
      this.currentUrl = this.$route.matched[0].path.replace(/\//, "");
    },
  },
};
</script>
<style scoped>
@import "https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap";
</style>
